import script from "./PaginationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationPanel.vue?vue&type=style&index=0&id=2f346f30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f346f30"]])

export default __exports__